import { Heading } from '@chakra-ui/react';
import { MdLogout } from 'react-icons/md';
import {
  MBox,
  MButton,
  MFlex,
  MIcon,
  MImage,
  MText,
} from '../../../../components/Monetize';

interface CustomerPortalHeaderProps {
  accountName: string;
  companyName?: string | null;
  companyLogo?: string | null;
  email: string;
  onLogout?: () => void;
  /** Hide the "Sign out" control when logout isn't supported (e.g. preview). */
  showLogout?: boolean;
}

export const CustomerPortalHeader = ({
  accountName,
  companyName,
  companyLogo,
  email,
  onLogout,
  showLogout = true,
}: CustomerPortalHeaderProps) => {
  return (
    <MBox
      as="header"
      bg="white"
      borderBottomWidth="1px"
      borderBottomStyle="solid"
      borderBottomColor="border.subtle"
    >
      <MBox
        maxW="80rem"
        mx="auto"
        px={{ base: 4, md: 8 }}
        py={{ base: 3, md: 4 }}
        display="grid"
        gridTemplateColumns="1fr auto 1fr"
        alignItems="center"
        gap={4}
      >
        <MBox minW={0} justifySelf="start" display="flex" alignItems="center">
          {companyLogo ? (
            <MImage
              src={`data:image/png;base64,${companyLogo}`}
              alt={`${companyName || 'Company'} logo`}
              maxH="40px"
              maxW="180px"
              objectFit="contain"
            />
          ) : companyName ? (
            <MText fontSize="sm" fontWeight={600} color="fg.strong">
              {companyName}
            </MText>
          ) : null}
        </MBox>

        <Heading
          as="h1"
          fontSize={{ base: 'md', md: 'xl' }}
          color="fg.strong"
          lineClamp={1}
          textAlign="center"
          justifySelf="center"
        >
          {accountName}
        </Heading>

        <MFlex minW={0} justifySelf="end" alignItems="center" gap={3}>
          {email && (
            <MText
              color="fg.muted"
              fontSize="sm"
              title={email}
              lineClamp={1}
              maxW="220px"
              display={{ base: 'none', md: 'block' }}
            >
              {email}
            </MText>
          )}
          {showLogout && onLogout && (
            <MButton
              variant="tertiary"
              size="sm"
              onClick={onLogout}
              leftIcon={<MIcon as={MdLogout} boxSize={4} />}
            >
              Sign out
            </MButton>
          )}
        </MFlex>
      </MBox>
    </MBox>
  );
};
